import { prop } from "../../decorators/property";

export class FullscreenReaderModel extends Backbone.AssociatedModel {
    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/fullscreen-reader.ts